import * as faqs from "./faqs";
import * as notifications from "./notifications";

export const center = {
    ...faqs,
    ...notifications,
}